function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { parseSelector } from 'vega-event-selector';
import { isString } from 'vega-util';
import { TUPLE, isTimerSelection } from '.';
import { varName } from '../../util';
import inputBindings from './inputs';
import toggle, { TOGGLE } from './toggle';
var clear = {
  defined: function defined(selCmpt) {
    return selCmpt.clear !== undefined && selCmpt.clear !== false && !isTimerSelection(selCmpt);
  },
  parse: function parse(model, selCmpt) {
    if (selCmpt.clear) {
      selCmpt.clear = isString(selCmpt.clear) ? parseSelector(selCmpt.clear, 'view') : selCmpt.clear;
    }
  },
  topLevelSignals: function topLevelSignals(model, selCmpt, signals) {
    if (inputBindings.defined(selCmpt)) {
      var _iterator = _createForOfIteratorHelper(selCmpt.project.items),
        _step;
      try {
        var _loop = function _loop() {
          var proj = _step.value;
          var idx = signals.findIndex(function (n) {
            return n.name === varName("".concat(selCmpt.name, "_").concat(proj.field));
          });
          if (idx !== -1) {
            signals[idx].on.push({
              events: selCmpt.clear,
              update: 'null'
            });
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return signals;
  },
  signals: function signals(model, selCmpt, _signals) {
    function addClear(idx, update) {
      if (idx !== -1 && _signals[idx].on) {
        _signals[idx].on.push({
          events: selCmpt.clear,
          update: update
        });
      }
    }
    // Be as minimalist as possible when adding clear triggers to minimize dataflow execution.
    if (selCmpt.type === 'interval') {
      var _iterator2 = _createForOfIteratorHelper(selCmpt.project.items),
        _step2;
      try {
        var _loop2 = function _loop2() {
          var proj = _step2.value;
          var vIdx = _signals.findIndex(function (n) {
            return n.name === proj.signals.visual;
          });
          addClear(vIdx, '[0, 0]');
          if (vIdx === -1) {
            var dIdx = _signals.findIndex(function (n) {
              return n.name === proj.signals.data;
            });
            addClear(dIdx, 'null');
          }
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } else {
      var tIdx = _signals.findIndex(function (n) {
        return n.name === selCmpt.name + TUPLE;
      });
      addClear(tIdx, 'null');
      if (toggle.defined(selCmpt)) {
        tIdx = _signals.findIndex(function (n) {
          return n.name === selCmpt.name + TOGGLE;
        });
        addClear(tIdx, 'false');
      }
    }
    return _signals;
  }
};
export default clear;